// ToggleButton.tsx

import { ButtonProps, Stack, Title } from '@mantine/core'
import { IconCaretLeftFilled } from '@tabler/icons-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { saveLocation } from '@/plugins/auth/RouteRedirectors/utils'

import classes from './BackButton.module.css'

interface BackButtonProps extends ButtonProps {
  exit?: boolean
  navTo?: string
  afterClick?: () => void
}

const BackButton: React.FC<BackButtonProps> = ({ exit = false, navTo = '', afterClick }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleClick = () => {
    if (navTo === 'cancelNav') {
      return
    }
    if (navTo) {
      saveLocation(navTo)
      navigate(navTo)
    } else navigate(-1)
    if (afterClick) {
      afterClick()
    }
  }

  return (
    <Stack className={classes.backButton} onClick={handleClick}>
      <IconCaretLeftFilled className={classes.icon} />
      <Title order={5}> {exit ? t('buttons.exit', 'Exit') : t('buttons.back', 'Back')}</Title>
    </Stack>
  )
}

export default BackButton
